<script>
  import Select from 'svelte-select';
  import FormInput from '../FormControls/FormInput.svelte';
  import { addHttpIfNot, customInputEvent, searchKeyByValue, validURL } from 'components/Helper.js';

  export let registrationTypes;
  export let registrationSubTypes;
  export let form;
  export let errors;
  export let handleChange;
  export let selectUnitsInfo;
  export let selectedRegistrationTypes;
  import { getContext } from 'svelte';
  const showDialog = getContext('showDialog');
  let selectedRegistrationTypesLabel;
  function addRegistrationType() {
    if (selectedRegistrationTypesLabel) {
      let arr = $form.registrationTypes;
      if (
        searchKeyByValue(arr, 'unitRegistrationTypeId', selectedRegistrationTypesLabel.id) !== -1
      ) {
        showDialog({ message: 'Registration type already selected' });
      } else {
        arr.push({
          id: '',
          unitRegistrationTypeId: selectedRegistrationTypesLabel.id,
          registrationUrl: '',
          registrationNo: '',
          subRegistrationTypes: [],
        });
        selectedRegistrationTypes.push({
          label: selectedRegistrationTypesLabel,
          types: null,
        });
        $form.registrationTypes = arr;
        selectedRegistrationTypesLabel = null;
      }
    } else {
      showDialog({ message: 'Please select registration type' });
    }
  }

  // $: if($form.registrationTypes.length == 0){
  //    addRegistrationType()
  //  }

  const removeRegistrationType = (key) => {
    let arr = $form.registrationTypes;
    arr.splice(key, 1);
    $form.registrationTypes = arr;

    let errorArr = $errors.registrationTypes;
    errorArr.splice(key, 1);
    $errors.registrationTypes = errorArr;

    let arrReg = selectedRegistrationTypes;
    arrReg.splice(key, 1);
    selectedRegistrationTypes = arrReg;
  };

  const setRegistrationSubTypes = (id) => {
    let arr = [];
    if (registrationSubTypes[id] != undefined) {
      arr = registrationSubTypes[id];
    }
    return arr;
  };
</script>

<div class="p-3 h-100 d-flex flex-column">
  <div class="profile-content mx-auto w-100">
    <div class="block-title mb-4">
      <h3 class="mt-0 title"><span>Registration Type *</span></h3>
    </div>
  </div>

  <div class="form-group mb-3">
    <div class="row align-items-center">
      <div class="col-md-3">
        <label
          for=""
          class="form-label mb-0">Registration Type</label
        >
      </div>
      <div class="col-md-6">
        <div class="form-group select-block">
          <Select
            class="form-control"
            bind:selectedValue={selectedRegistrationTypesLabel}
            showIndicator={true}
            isClearable={false}
            items={registrationTypes}
            getSelectionLabel={(option) => {
              return option.name;
            }}
            on:select={(ev) => {
              selectedRegistrationTypesLabel = ev.detail;
              addRegistrationType();
              setTimeout(() => {
                selectedRegistrationTypesLabel = undefined;
              }, 100);
            }}
            optionIdentifier="id"
            getOptionLabel={(option) => {
              return option.name;
            }}
            placeholder="Select Registration Type"
          />
        </div>
      </div>
      <!-- <div class="col-md-3">
		  <button
			on:click={addRegistrationType}
			class="btn btn-link px-0 mb-0 shadow-none border-0 font-size-12 bg-transparent">
			<img class="icon-10" alt="" src="/images/plus.svg" /> Add New
		  </button>
		</div> -->
    </div>
  </div>
  {#each $form.registrationTypes as item, i}
    <div class="form-group mb-3">
      <label
        for=""
        class="form-label">Registration Type</label
      >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group select-block">
            <Select
              isDisabled={true}
              class="form-control"
              bind:selectedValue={selectedRegistrationTypes[i].label}
              showIndicator={true}
              isClearable={false}
              items={registrationTypes}
              name={'registrationTypes[' + i + ']'}
              getSelectionLabel={(option) => {
                return option.name;
              }}
              on:select={(ev) => {
                if ($form.registrationTypes[i].unitRegistrationTypeId != ev.detail.id) {
                  $form.registrationTypes[i].unitRegistrationTypeId = ev.detail.id;
                  $form.registrationTypes[i].subRegistrationTypes = undefined;
                  $form.registrationTypes[i].id = '';
                  setTimeout(() => {
                    selectedRegistrationTypes[i].types = null;
                  }, 100);
                  handleChange(
                    customInputEvent(
                      `registrationTypes[${i}].unitRegistrationTypeId`,
                      ev.detail.id,
                    ),
                  );
                } else if (
                  setRegistrationSubTypes($form.registrationTypes[i].unitRegistrationTypeId)
                    .length > 0
                ) {
                  handleChange(
                    customInputEvent(
                      `registrationTypes[${i}].unitRegistrationTypeId`,
                      $form.registrationTypes[i].unitRegistrationTypeId,
                    ),
                  );
                }
              }}
              on:clear={(ev) => {}}
              optionIdentifier="id"
              getOptionLabel={(option) => {
                return option.name;
              }}
              placeholder="Select Registration Type"
            />
          </div>
        </div>
      </div>
    </div>
    {#if setRegistrationSubTypes($form.registrationTypes[i].unitRegistrationTypeId).length != 0}
      <div class="form-group mb-3">
        <label
          for=""
          class="form-label">Registration Sub Type</label
        >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <Select
                class="form-control"
                showIndicator={true}
                isClearable={false}
                bind:selectedValue={selectedRegistrationTypes[i].types}
                name={'subRegistrationTypes[' + i + ']'}
                items={setRegistrationSubTypes($form.registrationTypes[i].unitRegistrationTypeId)}
                getSelectionLabel={(option) => {
                  return option.name;
                }}
                on:select={(ev) => {
                  let subArr = [];
                  if (ev.detail !== null) {
                    ev.detail.forEach((element) => {
                      subArr.push({
                        id: '',
                        unitRegistrationTypeId: element.id,
                      });
                    });
                  }
                  $form.registrationTypes[i].subRegistrationTypes = subArr;
                }}
                on:clear={(ev) => {}}
                optionIdentifier="id"
                getOptionLabel={(option) => {
                  return option.name;
                }}
                placeholder="Select Registration Sub Type"
                isMulti={true}
              />
            </div>
          </div>
        </div>
      </div>
    {/if}
    <div class="row">
      {#if $form.registrationTypes[i].unitRegistrationTypeId > 0 && !selectUnitsInfo.outsourcedCfo}
        <div class="col-md-6">
          <div class="form-group mb-3">
            <FormInput
              name={`registrationTypes[${i}].registrationNo`}
              label="Registration No."
              type="text"
              placeholder="Registration No."
              error={$errors.registrationTypes[i] != undefined
                ? $errors.registrationTypes[i].registrationNo
                : undefined}
              bind:value={$form.registrationTypes[i].registrationNo}
              handleChange={handleChange}
            />
          </div>
        </div>
      {/if}
      {#if $form.registrationTypes[i].unitRegistrationTypeId > 0 && !selectUnitsInfo.outsourcedCfo}
        <div class="col-md-6">
          <div class="form-group mb-3">
            <FormInput
              name={`registrationTypes[${i}].registrationUrl`}
              label="URL"
              type="text"
              placeholder="Enter URL"
              error={$errors.registrationTypes[i] != undefined
                ? $errors.registrationTypes[i].registrationUrl
                : undefined}
              bind:value={$form.registrationTypes[i].registrationUrl}
              handleChange={(e) => {
                let arr = $form.registrationTypes;
                if (validURL($form.registrationTypes[i].registrationUrl)) {
                  let url = addHttpIfNot($form.registrationTypes[i].registrationUrl);
                  arr[i].registrationUrl = url;
                  handleChange(customInputEvent(`registrationTypes[${i}].registrationUrl`, url));
                  $form.registrationTypes = arr;
                } else {
                  handleChange(e);
                }
              }}
            />
          </div>
        </div>
      {/if}
    </div>
    <!-- {#if i == 0}
	  <hr />
	  <div class="d-flex justify-content-end mb-2">
		<button
		  on:click={addRegistrationType}
		  class="btn btn-link px-0 mb-0 shadow-none border-0 font-size-12 bg-transparent">
		  <img class="icon-10" alt="" src="/images/plus.svg" /> Add More
		</button>
	  </div>
	{:else} -->
    <div class="d-flex justify-content-end mb-2">
      <button
        on:click={() => removeRegistrationType(i)}
        class="btn btn-link px-0 mb-0 shadow-none border-0 font-size-12 color-red bg-transparent"
      >
        <img
          alt=""
          class="icon-16 me-1"
          src="/images/trash.svg"
        /> Remove
      </button>
    </div>
    <!-- {/if} -->
  {/each}
</div>
